import { Link } from 'react-router-dom';

interface LogoBrandProps {
  /** 'light' = white text (for dark backgrounds), 'dark' = dark text (for light backgrounds) */
  variant?: 'light' | 'dark';
  /** 'sm' | 'md' | 'lg' controls overall size */
  size?: 'sm' | 'md' | 'lg';
  /** Wrap in a Link to homepage */
  linkTo?: string;
  className?: string;
}

const SPACESHIP_URL =
  'https://storage.readdy-site.link/project_files/5346f5a7-cde1-4a45-9ba5-f838ee33b4ea/72f59052-0afe-43fd-967f-45cabae324d1_space-ship.png?v=86f4730185242241fef4990b4eda1b2d';

const sizeMap = {
  sm: { img: 'w-8 h-8',  title: 'text-base', sub: 'text-[9px]', gap: 'gap-2' },
  md: { img: 'w-11 h-11', title: 'text-xl',  sub: 'text-[10px]', gap: 'gap-3' },
  lg: { img: 'w-14 h-14', title: 'text-2xl', sub: 'text-xs', gap: 'gap-3' },
};

export default function LogoBrand({
  variant = 'light',
  size = 'md',
  linkTo,
  className = '',
}: LogoBrandProps) {
  const s = sizeMap[size];
  const titleColor = variant === 'light' ? 'text-[#FDB913]' : 'text-[#1a1a1a]';
  const subColor   = variant === 'light' ? 'text-white/60' : 'text-[#1a1a1a]/60';
  const borderColor = variant === 'light' ? 'border-[#FDB913]/50' : 'border-[#1a1a1a]/30';

  const inner = (
    <div className={`flex items-center ${s.gap} ${className}`}>
      {/* Spaceship icon */}
      <div className={`${s.img} flex-shrink-0 flex items-center justify-center`}>
        <img
          src={SPACESHIP_URL}
          alt="Serenity Law PLLC logo"
          className="w-full h-full object-contain"
        />
      </div>

      {/* Divider */}
      <div className={`self-stretch w-px ${borderColor} border-l`} />

      {/* Text */}
      <div className="flex flex-col leading-tight">
        <span
          className={`${s.title} font-black tracking-widest uppercase ${titleColor}`}
          style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.12em' }}
        >
          SERENITY LAW
        </span>
        <span
          className={`${s.sub} font-bold tracking-[0.25em] uppercase ${subColor}`}
          style={{ fontFamily: 'Arial, sans-serif' }}
        >
          PLLC · Tariff Refund Attorneys
        </span>
      </div>
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="cursor-pointer">
        {inner}
      </Link>
    );
  }

  return inner;
}
